import { render, staticRenderFns } from "./FormInputTextarea.vue?vue&type=template&id=dfada0cc&"
import script from "./FormInputTextarea.vue?vue&type=script&lang=js&"
export * from "./FormInputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports